export const VERSIONS = { Bremusa: 2, Clyemne: 3, Doris: 4, Euryleia: 5, Harmony: 6, Iphito: 7,
  IphitoFinal: 7.5, Kleoptoleme: 8, Vasya: 9, VasyaFinal: 10, Orithia: 11, Prothoe: 12, Scyleia: 13,
  Sometime: 999 };

export const CURRENT_RELEASE = VERSIONS.VasyaFinal;

const AvailableSince = (props) =>
  (CURRENT_RELEASE >= props.version ? props.children : null);

export default AvailableSince;
